import { createApiRef } from '@backstage/frontend-plugin-api';

import type { MsIamApi } from './types';

export const msApimAccessControlApiRef = createApiRef<MsIamApi>().with({
  id: 'plugin.ipen.ms-apim-access-control.api',
});
